import { render, staticRenderFns } from "./PersonCenterInfo.vue?vue&type=template&id=0859a11e&scoped=true"
import script from "./PersonCenterInfo.vue?vue&type=script&lang=js"
export * from "./PersonCenterInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonCenterInfo.vue?vue&type=style&index=0&id=0859a11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0859a11e",
  null
  
)

export default component.exports